import React from 'react'

export interface ImageProps {
    srcSmall?: [string, number]
    srcMedium?: [string, number]
    srcLarge?: [string, number]
    src: string
    alt: string
    className?: string
    lazyLoad?: boolean
}

export default function Image({
    srcSmall,
    srcMedium,
    srcLarge,
    src,
    alt,
    className,
    lazyLoad = true
}: ImageProps){
    const renderSource = (src, maxWidth) => {
        return src ? <source srcSet={src[0]} media={`(max-width: ${src[1]}px)`} /> : null
    }

    return (
        <picture>
            {renderSource(srcSmall, srcSmall && srcSmall[1])}
            {renderSource(srcMedium, srcMedium && srcMedium[1])}
            {renderSource(srcLarge, srcLarge && srcLarge[1])}
            <img
                src={src}
                alt={alt}
                title={alt}
                className={className}
                loading={lazyLoad ? 'lazy' : 'eager'}
            />
        </picture>
    )
}